import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-022fe303"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timetableSearchHome" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "inner" }

import { TimetableSearch, utcDate } from '@components';
import * as apiTypes from '@components/apiTypes';
import { useRouter } from 'vue-router';
import { formatInTimeZone } from 'date-fns-tz';
import { useTimetableStore } from '@components/stores';
import { parseISO } from 'date-fns';
import { timezone } from '../../envVariables';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimetableSearchHome',
  setup(__props) {

const router = useRouter();

const timetableStore = useTimetableStore();

const initialDate = utcDate(new Date()).toISOString();

const handleRedirect = (
  originPortName: string,
  destinationPortName: string,
  outboundDate: string,
  routeCode: string,
) => {
  if (!originPortName || !destinationPortName || !outboundDate || !routeCode) {
    return;
  }

  const newSearch: apiTypes.TimetableSearch = {
    from: originPortName,
    to: destinationPortName,
    fromDate: outboundDate,
    routeCode,
  };

  timetableStore.addSearchToRecent(newSearch);

  router.push({
    name: 'timetableResult',
    params: {
      from: encodeURI(originPortName),
      to: encodeURI(destinationPortName),
      departureDate: formatInTimeZone(parseISO(outboundDate), timezone, 'yyyy-MM-dd'),
    },
  });
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('Search timetables')), 1),
        _createVNode(_unref(TimetableSearch), {
          "button-text": _ctx.$t('View timetables'),
          "from-input-label": _ctx.$t('From'),
          "to-input-label": _ctx.$t('To'),
          "from-placeholder": _ctx.$t('Timetable search placeholder'),
          "to-placeholder": _ctx.$t('Timetable search placeholder'),
          "today-text": _ctx.$t('Today'),
          "initial-date": _unref(initialDate),
          onTimetableSearchClick: _cache[0] || (_cache[0] = (
            originPortName,
            destinationPortName,
            outboundDate,
            routeCode
          ) => handleRedirect(
            originPortName,
            destinationPortName,
            outboundDate,
            routeCode ))
        }, null, 8, ["button-text", "from-input-label", "to-input-label", "from-placeholder", "to-placeholder", "today-text", "initial-date"])
      ])
    ])
  ]))
}
}

})